import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormControl } from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { Observable } from "rxjs";
import { TableData } from "../md/md-table/md-table.component";
import { HDService } from "../services/hd.service";
import { UserService } from "../services/user.service";
import { ReportService } from "../services/report.service";
import { CompanylinkedService } from "../services/companylinked.service";
import { HdLinkToMasterService } from "../services/hdlinktomaster.service";
import { POService } from "../services/po.service";
import { formatDate } from "@angular/common";
import * as Chartist from "chartist";
import { GuiGuard } from "../shared/guard/base-gui-guard";
import { MatDialog } from "@angular/material/dialog";
import { ModalComponent } from "../modal/modal.component";
import { Methods } from "../shared/methods";
import swal from "sweetalert2";
import { Cell, DinamicData } from "../models/dinamic-data";
import { ManualityaddComponent } from "./manualityadd/manualityadd.component";
import { SecurazeService } from '../services/securaze.service';
import { MobilesdevicesService } from "../services/mobilesdevices.service"
declare const $: any;

declare const google: any;
/*
declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}*/

export interface UserList {
  value: string;
  name: string;
}

@Component({
  selector: "app-hdchecker",
  templateUrl: "./hdchecker.component.html",
  providers: [
    POService,
    UserService,
    HDService,
    ReportService,
    CompanylinkedService,
    HdLinkToMasterService,
    GuiGuard,
  ],
})
export class HdcheckerComponent implements OnInit, AfterViewInit {
  animal: string;
  name: string;
  public mtds: Methods = new Methods();
  public cerrado = false;
  public desbloquear = false;

  public typesearch: string = 'serialnumber';
  public arrayExport: Array<any> = [];
  public checked: any;

  public tableData: TableData;
  public dataTable: TableData;
  public pendientesTable: TableData;
  public dataTable1: TableData;
  public tableData1: TableData;
  public pickupsTable: TableData;
  public ArrivedTable: TableData;
  public privilegio;
  public identity;
  public token;
  public today;
  public y;
  public m;
  public d;
  public typeMatch = 0;
  public totalDiscs = 0;
  public totalDiscsDestroyed = 0;
  public advancedsearchtext: any = "";
  public qcearchtext: string = "";
  public destructionsearchtext: string = "";
  public destructionclientsname: string = "";
  public destructionclientscompany: any = "";
  public destructionpo: string = "";
  public destructionposelected: string = "";
  public posearchtext: string = "";
  public showMsgSearchingNotResults = 0;
  public qcshowMsgSearchingNotResults = 0;
  public qcshowMsgInfoResults = 0;
  public reportSaved = 0;
  public linkToMasterSaved = 0;
  public currentReport = 0;
  public poListDestruction: any[] = [];
  public loading: boolean = false;
  public showDates: boolean = false;

  public startDate: string = '';
  public endDate: string = '';

  public contMasterItemHDD = 0;
  public contMasterItemNOTHDD = 0;

  public destructionshowMsgInfoResults = 0;
  public addToMastershowMsgInfoResults = 0;
  public destructionshowMsgSearchingNotResults = 0;
  public destructionshowMsgSearchingFailedResults = 0;

  public showsearchResults = 0;
  public deepSearch: any = 0;
  public daysSearch = 0;
  public qcshowMsgSearchingFailedResults = 0;

  public qcManuallyPoNumber = "";
  public qcManuallySerialNumber = "";
  public qcManuallyModel = "";
  public qcManuallyManufacturer = "";
  public qcShowAddManually: boolean = false;

  public summaryTotal = {};

  public hdlinkpo = "";
  public hdLinkSerialRemove = "";
  public hdLinkAssetRemove = "";

  public multipleHDD: boolean = false;
  public destructionManuallySerialNumber = "";
  public destructionManuallyDate = "";

  public poshowMsgSearchingFailedResults = 0;
  public poshowMsgSearchingNotResults = 0;
  public hdlinkshowEmpty = 0;
  public hdlinkshowEmptySearch = 0;
  public poshowMsgInfoResults = 0;
  public msgerrorqc = "";
  public msgerrorpo = "";
  public msgerrorhdlink = "";
  public msgerrorhdlinkSearch = "";
  public msgerrordestruction = "";
  public responseHDSN = {
    id: "",
    ErasureResults: "",
    PoNumber: "",
    Manufacturer: "",
    Model: "",
    SerialNumber: "",
    Capacity: "",
    BlockSize: "",
    FormFactor: "",
    RPM: "",
    HealthScore: "",
    ReallocatedSectors: "",
    PendingBadSectors: "",
    PowerOnHours: "",
    ErasureMethod: "",
    ErasureEndDate: "",
    ErasureStartDate: "",
    identifier: "",
    iqInfo: "",
    microcode: "",
    SerialNumber_new: "",
    grade: "",
    ParentInfo: "",
    Vendor: "",
  };

  public alertWrongErasureMethod: boolean = false;
  public alertHoldBadHardDrives: string = "";

  myControlCompanies = new FormControl();
  myControlCompaniesDestruction = new FormControl();

  public dataDailySalesChart = {
    labels: ["PASSED", "FAILED"],
    series: [],
  };
  public companies;
  public phonecheckshow = false;
  public qtyPassed = 0;
  public qtyFailed = 0;
  public qtyPartial = 0;

  companiesList: UserList[] = [];
  companiesListDestruction: UserList[] = [];

  public arrayTrucks: any[] = [];

  public responseQCInspection: any[] = [];
  public responsePOsearch: Array<any> = [];
  public responsePOsearch_bkp: any[] = [];

  public responseDestructionReport: any[] = [];
  public responseHdLinkToMaster: any[] = [];
  public companySelected;
  public companySelected2;
  public poSelected;
  public poSelectedDestruction;
  public SerialNumberMasterItem;
  public childitemSerialNumber;
  public childAssetag;
  public masterSaved;
  public currentHdLink = 0;
  public destructionclientscompany2: any;
  public userlogged;
  public apiCompany;
  public stateDate = false;
  //Se usan para jalar todo lo de securaze
  public isSecuraze = false;

  public securazeSerialNumber;
  public securazeVendor;
  public securazeType;
  public securazeChassis;
  public securazeName;
  public securazePO;

  public batteries: string[][];
  public colli: string[][];
  public disc_drives: string[][];
  public gpus: string[][];
  public memory: string[][];
  public motherboards: string[][];
  public network_interfaces: string[][];
  public processors: string[][];

  public batteriesCollapse: boolean = false;
  public disc_drivesCollapse: boolean = false;
  public gpusCollapse: boolean = false;
  public memoryCollapse: boolean = false;
  public motherboardsCollapse: boolean = false;
  public network_interfacesCollapse: boolean = false;
  public processorsCollapse: boolean = false;

  public apiToken;
  public pxe;

  public isEPSPXE: boolean = false;

  filteredCompanies: Observable<UserList[]>;
  filteredCompaniesDestruction: Observable<UserList[]>;

  public bitrasershow = false;

  constructor(
    private titleService: Title,
    private _userService: UserService,
    private _hdService: HDService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _reportService: ReportService,
    private _hdLinkToMasterService: HdLinkToMasterService,
    private _companylinkedService: CompanylinkedService,
    public dialog: MatDialog,
    private _poService: POService,
    private _securazeService: SecurazeService,
    private mobilesdevicesService: MobilesdevicesService
  ) {
    this.titleService.setTitle("HDD Tools");
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    console.log(this.identity);
    this.apiCompany = this.identity.apiCompany;
    console.log(this.apiCompany);
    this.getAllCompanies();

    if (this.token) {
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.userlogged = response.data;
            // this.apiCompany = this.userlogged.companyLinked.apiToken;
            //  console.log(this.apiCompany);
            this.apiToken = response.data.companyLinked.apiToken;
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }

    this.arrayExport = [];

    this._route.params.forEach((params: Params) => {
      this.currentReport = +params["id"];
      if (isNaN(this.currentReport)) {
        this.currentReport = 0;
      }
      console.log("currentReport: " + this.currentReport);

      this.getReportsFromConstructor(this.currentReport);
    });

    this.today = new Date();
    this.y = this.today.getFullYear();
    var month = new Array();
    month[0] = "Enero";
    month[1] = "Febrero";
    month[2] = "Marzo";
    month[3] = "Abril";
    month[4] = "Mayo";
    month[5] = "Junio";
    month[6] = "Julio";
    month[7] = "Agosto";
    month[8] = "Septiembre";
    month[9] = "Octubre";
    month[10] = "Noviembre";
    month[11] = "Diciembre";
    this.m = month[this.today.getMonth()];
    this.d = this.today.getDate();
  }

  public loadingRange: boolean = false;
  DowloandReportHDD() {
    const url = 'https://itaderp.com/joseha/Reporthdd.php';
  
    // Creamos el formulario dinámicamente
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';
  
   
    const inputSince = document.createElement('input');
    inputSince.type = 'hidden';
    inputSince.name = 'sincedate';
    inputSince.value = this.startDate;
  
    const inputTo = document.createElement('input');
    inputTo.type = 'hidden';
    inputTo.name = 'todate';
    inputTo.value = this.endDate;
  
    
    form.appendChild(inputSince);
    form.appendChild(inputTo);
  
   
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
  
  openModalRange(){
    if((this.startDate !== '') && (this.endDate !== '')){
        this.stateDate = true;
    }else{
        this.stateDate = false;
    }
    $('#dateRangeModal').modal('show');
  }


  resetData(){
      this.totalDiscs = 0;
      this.totalDiscsDestroyed = 0;
      this.getAllCompanies();
      this.startDate = '';
      this.endDate = ''; 
    $('#dateRangeModal').modal('hide');

    this._hdService.getHDDetails(this.apiCompany).subscribe(
      (response) => {
        this.totalDiscs = response.totalHDS;
        this.totalDiscsDestroyed = response.totalHDDestroyed;

        this.dataDailySalesChart = {
          labels: ["PASSED", "FAILED"],
          series: [[response.totalHDS, response.totalHDDestroyed]],
        };
        console.log(this.dataDailySalesChart);

        const optionsDailySalesChart = {
          lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: this.totalDiscs, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: { top: 0, right: 0, bottom: 0, left: 15 },
        };

        const dailySalesChart = new Chartist.Line(
          "#dailySalesChart",
          this.dataDailySalesChart,
          optionsDailySalesChart
        );

        this.startAnimationForLineChart(dailySalesChart);
      },
      (error) => {
        console.log(<any>error);
      }
    );

  }

  generateReportByRange(): void {
    this.loadingRange = true;
    if (this.startDate && this.endDate) {
      this._hdService.getHDDetails(this.apiCompany, this.startDate, this.endDate).subscribe(response => {
        //console.log('Reporte generado:', response);
        this.loadingRange = false;
        this.totalDiscs = response.totalHDS;
        this.totalDiscsDestroyed = response.totalHDDestroyed;
        $('#dateRangeModal').modal('hide');
      });
      
    } else {
      console.log('Por favor, selecciona ambas fechas');
    }
  }

  async getReportsFromConstructor(report) {
    this._reportService.getReport(this.token, report).subscribe(
      async (response) => {
        let responseReport = response;
        console.log(response);
        if (response.status == "success") {
          //this.cerrado = (response.data.type === 'PHYSICALDESTRUCTION');
          //this.desbloquear = (this.identity.role === 'ADMINISTRATOR' || this.identity.sub === response.data.user.id);

          this.cerrado = response.data.name !== "pending";
          this.desbloquear = true;

          this.statusContainerByPhysicalDestruction = true;

          this.getReports();
          /*this.responseDestructionReport = JSON.parse(response.data.data);
            console.log(this.responseDestructionReport);
            let size = this.responseDestructionReport.length - 1;
            this.destructionclientsname = this.responseDestructionReport[size].clientsname;
            $("#destructionhdresults").show();*/

          if ((await typeof responseReport) !== "undefined")
            this._companylinkedService
              .getCompanyByPo(this.token, response.data.pO)
              .subscribe(
                (response2) => {
                  console.log(response2);
                  if (response2.status == "success") {
                    this.destructionclientscompany = response2.data.name;
                    this.destructionclientscompany2 = response2.data.id;
                    this._poService
                      .getAllPOsLiteByCompany(this.token, response2.data.id)
                      .subscribe(
                        (response3) => {
                          if (response3.status == "success") {
                            this.loading = false;
                            this.poListDestruction = response3.data;
                            this.poSelected = "";
                            this.destructionpo = response.data.pO;
                            this.getReports();
                          }
                        },
                        (error) => {
                          console.log(<any>error);
                        }
                      );
                  }
                },
                (error) => {
                  console.log(<any>error);
                }
              );
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  manualityAddDialog(): void {
    const dialogRef = this.dialog.open(ManualityaddComponent, {
      width: "40%",
      data: {
        manufacturer: "",
        model: "",
        serial_number: "",
        results: "",
        serial_number_new: "",
        po: this.posearchtext,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  changeTypeSearch() {
    this.isEPSPXE = false;
    console.log(this.typesearch);
    if (this.typesearch == "po") {
      this.posearchtext = this.advancedsearchtext;
    }
  }

  collapse(value) {
    this.batteriesCollapse = false;
    this.disc_drivesCollapse = false;
    this.gpusCollapse = false;
    this.memoryCollapse = false;
    this.motherboardsCollapse = false;
    this.network_interfacesCollapse = false;
    this.processorsCollapse = false;

    if (value === "Batteries") {
      this.batteriesCollapse = true;
    }

    if (value === "Disc") {
      this.disc_drivesCollapse = true;
    }

    if (value === "Gpus") {
      this.gpusCollapse = true;
    }

    if (value === "Memory") {
      this.memoryCollapse = true;
    }

    if (value === "Motherboards") {
      this.motherboardsCollapse = true;
    }

    if (value === "Network") {
      this.network_interfacesCollapse = true;
    }

    if (value === "Processors") {
      this.processorsCollapse = true;
    }
  }

  clearEPSPXE(){
    this.isEPSPXE = false;
  }

  selectAll() {
    let psicion = this.page * this.perpage;
    const ischeck = this.checkAll();
    console.log(ischeck);
    for (let idx = psicion; idx < psicion + this.perpage; idx++) {
      const idx2 = this.arrayExport.indexOf(this.responsePOsearch[idx].id);
      if (ischeck && idx2 !== -1) {
        this.arrayExport.splice(idx2, 1);
      } else if (!ischeck && idx2 === -1) {
        this.arrayExport.push(this.responsePOsearch[idx].id);
      }
    }

    setTimeout(() => {
      this.table.page(this.page).draw("page");
    }, 1);
    // for (let i = 0; i < this.page; i++) {
    // }
  }

  checkAll() {
    let psicion = this.page * this.perpage;
    for (let idx = psicion; idx < psicion + this.perpage; idx++) {
      if (
        this.responsePOsearch.length &&
        !this.arrayExport.includes(this.responsePOsearch[idx].id)
      ) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    const idx = this.arrayExport.indexOf(id);
    if (idx !== -1) {
      this.arrayExport.splice(idx, 1);
    } else {
      this.arrayExport.push(id);
    }
  }

  isCheck(id) {
    return this.arrayExport.includes(id);
  }

  cleanBulk() {
    this.arrayExport = [];
  }

  public resultDDSN = {
    ErasureEndDate: "",
    SerialNumber: "6SJ7F6DA",
    clientsname: "Right Away Tech Sales",
    id: 45,
    po: "",
  };

  searchDDSN() {
    $("#showMsgSearchingNotResults").hide();
    $("#poshowMsgSearchingNotResults").hide();

    // if (isNaN(this.advancedsearchtext)) return;

    if (this.advancedsearchtext == "") {
      return;
    }

    this.advancedsearchtext = this.advancedsearchtext.trim();

    $("#hdresults").hide();
    $("#hdddsnresults").hide();
    $("#hdporesults").hide();
    $("#showMsgSearching").show();
    this.isSecuraze = false;
    this.isEPSPXE = false;

    this.poshowMsgSearchingNotResults = 0;
    this.poshowMsgInfoResults = 0;
    this.poshowMsgSearchingFailedResults = 0;
    $("#hdporesults").hide();

    this._reportService
      .search(this.token, { q: this.advancedsearchtext })
      .subscribe(
        (r) => {
          console.log(r);
          $("#showMsgSearching").hide();

          if (r.data.length > 0) {
            let result = JSON.parse(r.data[0].data);
            this.resultDDSN.SerialNumber = result.SerialNumber;
            this.resultDDSN.clientsname = result.clientsname;
            this.resultDDSN.clientsname = result.clientsname;
            this.resultDDSN.id = result.id;
            this.resultDDSN.po = r.po;
            console.log(this.resultDDSN);
            $("#hdddsnresults").show();
          } else {
            this.showMsgSearchingNotResults = 1;
            $("#showMsgSearchingNotResults").show();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  searchSecuraze() {
    $("#showMsgSearchingNotResults").hide();
    $("#poshowMsgSearchingNotResults").hide();
    this.isSecuraze = false;
    this.isEPSPXE = false;
    // if (isNaN(this.advancedsearchtext)) return;

    if (this.advancedsearchtext == "") {
      return;
    }

    this.advancedsearchtext = this.advancedsearchtext.trim();

    $("#hdresults").hide();
    $("#hdddsnresults").hide();
    $("#hdporesults").hide();
    $("#showMsgSearching").show();

    this.poshowMsgSearchingNotResults = 0;
    this.poshowMsgInfoResults = 0;
    this.poshowMsgSearchingFailedResults = 0;
    $("#hdporesults").hide();

    this._reportService
      .searchSecuraze(this.token, { q: this.advancedsearchtext })
      .subscribe(
        (response) => {
          console.log(response);
          $("#showMsgSearching").hide();

          if (response.status === "success") {
            this.batteries = [];
            this.colli = [];
            this.disc_drives = [];
            this.gpus = [];
            this.memory = [];
            this.motherboards = [];
            this.network_interfaces = [];
            this.processors = [];

            this.batteries = response.batteries;
            this.colli = response.colli;
            this.disc_drives = response.disc_drives;
            this.gpus = response.gpus;
            this.memory = response.memory;
            this.motherboards = response.motherboards;
            this.network_interfaces = response.network_interfaces;
            this.processors = response.processors;

            this.securazeSerialNumber = response.product.serialnumber;
            this.securazeVendor = response.product.vendor;
            this.securazeType = response.product.type;
            this.securazeChassis = response.product.chassis;
            this.securazeName = response.product.name;
            this.securazePO = response.product.po;

            /*this.inventory = response.inventory;
          this.searchValue = response.inventory.inventoryid;
          this.podate = this.getFecha(this.inventory.po.date);
          this.id_inventory = response.inventory.id;*/

            this.isSecuraze = true;
          } else {
            this.showMsgSearchingNotResults = 1;
            $("#showMsgSearchingNotResults").show();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getAllCompanies() {
    this._companylinkedService.getAllCompaniesLite(this.token, "all").subscribe(
      (response) => {
        console.log(response);
        if (response.status == "success") {
          this.companies = response.data;
          console.log(this.companies);
          response.data.forEach(
            function (element) {
              this.companiesList.push({
                value: element.id,
                name: element.name + " # " + element.id,
              });
              this.companiesListDestruction.push({
                value: element.id,
                name: element.name + " # " + element.id,
              });
            }.bind(this)
          );
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ModalComponent, {
      width: "80%",
      data: this.responseHDSN,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (typeof result === "undefined") {
        return;
      } else {
        let dataActualizar = {
          idhd: result.id,
          viejo: result.SerialNumber,
          nuevo: result.q,
        };
        this._hdLinkToMasterService
          .updateSerialHD(this.token, dataActualizar)
          .subscribe(
            (response) => {
              console.log(response);
            },
            (error) => {
              console.log(<any>error);
            }
          );
        this.typeMatch = 0;
        this.responseHDSN = null;
        this.responseHDSN = result;
        this.showsearchResults = 1;
        this.showMsgSearchingNotResults = 0;
        $("#hdresults").show();
      }
    });
  }
  openDialog2(): void {
    $("#showMsgSearching").hide();
    this.isEPSPXE = true;
    /*const dialogRef = this.dialog.open(InventoryAttributesComponent, {
      width: "100%",
      height: "auto",
      data: {
        deepSearch: this.advancedsearchtext,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });*/
  }
  getdatabitraser() {
    return new Promise((resolve, reject) => {
        
        this._securazeService.gedatabitraser(this.token, this.advancedsearchtext).subscribe(
            (response) => {
                console.log("getdatabt");
                console.log(response);
                if (response.status === "success") {
                    this.bitrasershow = true;
                    resolve(response); 
                } else {
                    this.bitrasershow = false;
                    resolve(response); 
                }
            },
            (error) => {
                console.log(error);
                reject(error); 
                this.mtds.notifyError('Error');
            }
        );
    });
}
getphonecheck() {
  this.phonecheckshow = false
  return new Promise((resolve, reject) => {
    this.mobilesdevicesService.Getphonecheckdata(this.advancedsearchtext).subscribe(
          (response) => {
              console.log("getdataphone");
              console.log(response);
              if (response.status === "success") {
                  this.phonecheckshow = true;
                  resolve(response); 
              } else {
                  this.phonecheckshow = false;
                  resolve(response); 
              }
          },
          (error) => {
              console.log(error);
              reject(error); 
              this.mtds.notifyError('Error');
          }
      );
  });
}
/*   getEPSSZE(type){
    this.advancedsearchtext = this.advancedsearchtext.trim();

    let json = {
      type: type
    }

    this._reportService
      .getEPSSZE(this.token, this.advancedsearchtext, json)
      .subscribe(
        async (response) => {

          console.log(response);
          $("#showMsgSearching").hide();

          if (response.status === "success") {

            if (type === 'id')
              this.advancedsearchtext = response.id;
            await this.getdatabitraser();
            await this.getphonecheck();
            if(response.flagsze === 0 && response.flageps === 0 && this.bitrasershow === false && this.phonecheckshow === false){
              this.showMsgSearchingNotResults = 1;
              $("#showMsgSearchingNotResults").show();  
            } else if (this.bitrasershow === true && response.flagsze === 0 && response.flageps === 0 || this.phonecheckshow === true && response.flagsze === 0 && response.flageps === 0) {
              this.openDialog2();
            } else if(response.flagsze === 1 && response.flageps === 0){
              this.searchSecuraze();
            } else if(response.flagsze === 0 && response.flageps === 1){
              this.openDialog2();
            } else if(response.flagsze === 1 && response.flageps === 1){
              $('#modalEPSSZE').modal('show');
            }

          } else {
            this.mtds.notifyError('Error');
          }
        },
        (error) => {
          console.log(error);
        }
      );
  } */
  async getEPSSZE(type) {
    this.advancedsearchtext = this.advancedsearchtext.trim();
  
    let json = { type: type };
  
    this._reportService.getEPSSZE(this.token, this.advancedsearchtext, json)
      .subscribe(async (response) => {
        console.log(response);
        $("#showMsgSearching").hide();
  
        if (response.status === "success") {
          if (type === 'id') {
            this.advancedsearchtext = response.id;
          }
          if(response.flagsze === 0 && response.flageps === 1){
            this.openDialog2();
          
            return; 
          }
       
          try {
            await this.getdatabitraser(); 
          } catch (error) {
            console.error(error);
          }
          if (this.bitrasershow === true) {
            this.openDialog2(); 
            return;
          }
        
          try {
            await this.getphonecheck();
          } catch (error) {
            console.error(error);
          }
          if (this.phonecheckshow === true) {
            this.openDialog2(); 
            return;
          }
          if(response.flagsze === 1 && response.flageps === 1){
            $('#modalEPSSZE').modal('show');
          }
          this.searchSecuraze();
        } else {
          this.mtds.notifyError('Error');
        }
      }, (error) => {
        console.log(error);
      });
  }
  
  chooseEPSSZE(param){
    $('#modalEPSSZE').modal('hide');

    if(param === 'securaze')
      this.searchSecuraze();
    else
      this.openDialog2();
  }

  removeElementFromPOTable(value) {
    this.responsePOsearch = this.responsePOsearch.filter(function (ele) {
      return ele.id != value;
    });
  }

  delete(value) {
    swal
      .fire({
        title: "Are you sure to remove this Hard Drive?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then((result) => {
        if (result.value) {
          this.remove([value]);
        }
      });
  }

  deletebulk() {
    swal
      .fire({
        title: "Are you sure to remove selected Hard Drives?",
        text: "",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then((result) => {
        if (result.value) {
          this.remove(this.arrayExport);
        }
      });
  }

  public borrando = false;

  remove(valores) {
    let array = [];
    for (let v of valores) {
      array.push(Number(v));
    }
    const json = { bulk: array };
    this.borrando = true;

    this._hdService.removebulk(this.token, json, this.apiToken).subscribe(
      (r) => {
        if (r.status === "success") {
          for (let id of valores) {
            this.removeElementFromReportTable(id);
          }

          swal.fire({
            title: "Success",
            text:
              valores.length > 1
                ? "Hard drives have been removed successfully"
                : "The hard drive has been removed successfully",
            buttonsStyling: false,

            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          this.mtds.notifyError(r.msg ? r.msg : "Something went wrong!");
        }
        this.borrando = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.borrando = false;
      }
    );
  }

  removeElementFromReportTable(value) {
    console.log(value);

    for (let i = 0; i < this.responsePOsearch.length; i++) {
      if (this.responsePOsearch[i].id === value) {
        this.responsePOsearch.splice(i, 1);
        break;
      }
    }
    // this.responseQCInspection = this.responseQCInspection.filter(function (ele) {
    //   return ele.id != value;
    // });
  }

  removeElementFromDestructionTable(value) {
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    this.responseDestructionReport = this.responseDestructionReport.filter(
      function (ele) {
        return ele.id != value;
      }
    );
    var myJSON = JSON.stringify(this.responseDestructionReport);
    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.poSelectedDestruction,
      name: fechaHoy,
      type: "PDTEMP",
      data: myJSON,
    };
    this._reportService
      .update(this.token, this.currentReport, dataEnviar)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.status == "success") {
            this.reportSaved = 1;
            this.currentReport = response.data.id;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  public saving = false;

  saveDestructionReport() {
    this.reportSaved = 0;
    this.saving = true;
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    console.log(fechaHoy);
    // this.responseDestructionReport.push({"clientsname": this.destructionclientsname});
    // var myJSON = JSON.stringify(this.responseDestructionReport);

    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.poSelectedDestruction,
      name: fechaHoy,
      type: "PDTEMP",
      data: null,
    };
    if (this.currentReport > 0) {
      this.saveDisk();
      /*
        this._reportService.update(this.token, this.currentReport, dataEnviar).subscribe(
          response => {
            console.log(response);
            if (response.status == 'success') {
              this.reportSaved = 1;
              this.currentReport = response.data.id;
            }
          },
          error => {
            console.log(<any>error);
          });
      */
    } else {
      this._reportService.new(this.token, dataEnviar).subscribe(
        (response) => {
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
            this.saving = false;
          } else if (response.status === "success") {
            console.log(response);
            this.reportSaved = 1;
            this.currentReport = response.data.id;
            this.saveDisk();
          } else {
            this.mtds.notifyError(response.msg, response.code);
            this.saving = false;
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
    }
  }

  saveDisk() {
    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.destructionManuallySerialNumber =
      this.destructionManuallySerialNumber.replace(".", "");
    let serialnumberenviar = this.destructionManuallySerialNumber;
    let erasuredateneviar = this.destructionManuallyDate;
    let json = {
      id: idrandom,
      SerialNumber: serialnumberenviar,
      ErasureEndDate: erasuredateneviar,
      clientsname: this.destructionclientsname,
    };
    this._reportService
      .enviarDisco(this.token, this.currentReport, json)
      .subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            this.destructionManuallySerialNumber = "";
            this.getReports();
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
          this.saving = false;
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
          this.saving = false;
        }
      );
  }

  tooglefechas() {
    this.showDates = !this.showDates;
  }

  generateReport() {
    console.log(this.responseQCInspection);

    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    console.log(fechaHoy);
    var myJSON = JSON.stringify(this.responseQCInspection);

    let dataEnviar = {
      user_id: this.identity.sub,

      name: fechaHoy,

      type: "QCINSPECTION",

      data: myJSON,
    };

    this._reportService.new(this.token, dataEnviar).subscribe(
      (response) => {
        console.log(response);

        if (response.status == "success") {
          var r = confirm("Press Ok to see report");
          if (r == true) {
            window.open(
              "https://www.itaderp.com/backend/reports/view-report.php?id=" +
                response.data.id +
                "&typeReport=" +
                response.data.type +
                "",
              "_blank"
            );
            this.responseQCInspection = [];
          } else {
          }
        } else {
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  public dataposearch: DinamicData = new DinamicData([
    "check",
    "Manufacturer",
    "Model",
    "Serial Number",
    "Serual Number New",
    "Results",
    "PO",
    "Actions",
  ]);

  public bulk = [];

  action(e) {
    console.log(e);
  }

  public page = 1;
  public perpage = 5;
  public table;

  searchByPO() {
    $("#showMsgSearchingNotResults").hide();
    $("#poshowMsgSearchingNotResults").hide();

    //if (isNaN(this.advancedsearchtext))
    //return;

    if (this.advancedsearchtext == "") {
      return;
    }

    $("#hdresults").hide();
    $("#hdddsnresults").hide();
    $("#hdporesults").hide();
    $("#poshowMsgSearching").show();
    this.isSecuraze = false;
    this.isEPSPXE = false;

    this.poshowMsgSearchingNotResults = 0;
    this.poshowMsgInfoResults = 0;
    this.poshowMsgSearchingFailedResults = 0;
    $("#hdporesults").hide();

    this._hdService
      .searchHDByPO(this.advancedsearchtext, "false", this.apiCompany)
      .subscribe(
        (response) => {
          // console.log(response);
          if (response == "po must be numeric") {
            $("#poshowMsgSearching").hide();
            return;
          }

          this.posearchtext = this.advancedsearchtext;
          this.advancedsearchtext = "";

          $("#poshowMsgSearching").hide();

          if (response.length > 0) {
            $("#exampleTable").DataTable().clear();
            $("#exampleTable").DataTable().destroy();

            this.poshowMsgSearchingNotResults = 0;

            this.responsePOsearch = response;

            this.responsePOsearch_bkp = response;

            this.dataposearch.rows = [];
            this.bulk = [];

            // for (let element of response) {
            //   const actionButtons = [ { icon: 'delete_outline', action: 'Remove', color: 'danger', value: element.id } ]
            //   this.dataposearch.rows.push (
            //     [
            //       new Cell(element.id, {type: 'checkbox'}),
            //       new Cell(element.Manufacturer),
            //       new Cell(element.Model),
            //       new Cell(element.SerialNumber),
            //       new Cell(element.SerialNumber_new),
            //       new Cell(element.ErasureResults),
            //       new Cell(element.PoNumber),
            //       new Cell(actionButtons, {type: 'actions'})
            //     ]
            //   )
            // }

            this.qtyPassed = this.responsePOsearch.filter(
              (x) => x.ErasureResults == "PASSED"
            ).length;
            this.qtyFailed = this.responsePOsearch.filter(
              (x) =>
                x.ErasureResults == "FAILED" ||
                x.ErasureResults == "FAILED (Modified)"
            ).length;
            this.qtyPartial = this.responsePOsearch.filter(
              (x) => x.ErasureResults == "PARTIAL"
            ).length;

            $("#hdporesults").show();

            this.page = 0;
            this.perpage = 5;

            setTimeout(() => {
              var table = $("#exampleTable").DataTable({
                dom: "Bflrtip",
                buttons: [
                  /*{
                    extend: 'copy',
                    exportOptions: {
                      columns: ':visible'
                    }
                  },*/ /*
                  {
                    extend: 'csv',
                    exportOptions: {
                      columns: ':visible'
                    }
                  },*/
                  {
                    extend: "excel",
                    text: `<i class='fa fa-file-excel-o'></i>`,
                    titleAttr: "Excel",
                    className: "btn btn-sm btn-outline-success",
                    exportOptions: {
                      columns: ":visible",
                    },
                  },
                  {
                    extend: "pdf",
                    text: `<i class='fa fa-file-pdf-o'></i>`,
                    titleAttr: "PDF",
                    className: "btn btn-sm btn-outline-danger",
                    exportOptions: {
                      columns: ":visible",
                    },
                  },
                  {
                    extend: "print",
                    text: `<i class='fa fa-print' aria-hidden='true'></i>`,
                    titleAttr: "primary",
                    className: "btn btn-sm btn-outline-primary",
                    exportOptions: {
                      columns: ":visible",
                    },
                  },
                ],
                pagingType: "full_numbers",
                lengthMenu: [
                  [5, 10, 25, 50, 100, 200, 500, 1000, -1],
                  [5, 10, 25, 50, 100, 200, 500, 1000, "All"],
                ],
                responsive: true,
                language: {
                  search: "_INPUT_",
                  searchPlaceholder: "Search records",
                },
              });
              $("#exampleTable").on("page.dt", () => {
                var info = table.page.info();
                console.log(info);
                this.page = info.page;
              });

              $("#exampleTable").on("length.dt", () => {
                var info = table.page.info();
                this.page = info.page;
                this.perpage = info.length;
                console.log(info);
              });

              this.table = table;
            }, 1);
          } else {
            this.poshowMsgSearchingNotResults = 1;
            this.msgerrorpo = "No records found in this PO, please try again";
            return;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  changeDataArray(value) {
    if (value == "ALL") {
      this.responsePOsearch = this.responsePOsearch_bkp;
    } else if (value == "FAILED") {
      this.responsePOsearch = this.responsePOsearch_bkp.filter(
        (x) =>
          x.ErasureResults == value || x.ErasureResults == "FAILED (Modified)"
      );
    } else {
      this.responsePOsearch = this.responsePOsearch_bkp.filter(
        (x) => x.ErasureResults == value
      );
    }
  }

  getOccurrence(array, value) {
    return array.filter((v) => v === value).length;
  }

  searchDestructionReport() {
    if (this.destructionsearchtext == "") {
      return;
    }

    $("#destructionshowMsgSearching").show();
    this.isSecuraze = false;
    this.isEPSPXE = false;

    this.destructionshowMsgSearchingNotResults = 0;
    this.destructionshowMsgInfoResults = 0;
    this.destructionshowMsgSearchingFailedResults = 0;
    // $("#destructionhdresults").hide();

    this._hdService
      .searchHDBySerialNumber(
        this.destructionsearchtext,
        "false",
        this.daysSearch,
        this.apiCompany
      )
      .subscribe(
        (response) => {
          console.log(response);
          this.destructionsearchtext = "";

          $("#destructionshowMsgSearching").hide();

          if (response.length > 0) {
            this.destructionshowMsgSearchingNotResults = 0;
            $("#destructionhdresults").show();
          } else {
            this.destructionshowMsgSearchingNotResults = 1;
            this.msgerrordestruction = "No records found, please try again";
            return;
          }

          var found = this.responseDestructionReport.find(function (element) {
            console.log(element.SerialNumber);

            return element.SerialNumber == response[0].SerialNumber;
          });

          if (response[0].ErasureResults == "PASSED") {
            console.log("1");
            this.msgerrordestruction =
              "Failed – This hard drive has PASSED the erasure and/or testing.";
            this.destructionshowMsgSearchingNotResults = 1;
          } else if (found) {
            console.log("2");
            this.destructionshowMsgInfoResults = 1;
          } else {
            console.log("3");
            this.responseDestructionReport.push(response[0]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  searchQCInspection() {
    if (this.qcearchtext == "") {
      return;
    }

    this.qcearchtext = this.qcearchtext.replace(".", "");
    console.log(this.qcearchtext);

    $("#qcshowMsgSearching").show();

    this.qcshowMsgSearchingNotResults = 0;
    this.qcshowMsgInfoResults = 0;
    this.qcshowMsgSearchingFailedResults = 0;
    $("#hdresults").hide();
    this.isSecuraze = false;
    this.isEPSPXE = false;

    this._hdService
      .searchHDBySerialNumber(
        this.qcearchtext,
        "false",
        this.daysSearch,
        this.apiCompany
      )
      .subscribe(
        (response) => {
          console.log(response);
          this.qcearchtext = "";

          $("#qcshowMsgSearching").hide();

          if (response.length > 0) {
            this.qcshowMsgSearchingNotResults = 0;
            $("#qchdresults").show();
          } else {
            this.qcshowMsgSearchingNotResults = 1;
            this.msgerrorqc = "No records found, please try again";
            return;
          }

          var found = this.responseQCInspection.find(function (element) {
            console.log(element.SerialNumber);

            return element.SerialNumber == response[0].SerialNumber;
          });

          if (response[0].ErasureResults == "FAILED") {
            console.log("1");
            this.msgerrorqc =
              "Failed – This hard drive has failed the erasure and/or testing. This hard drive can’t be resold and it needs to be destroyed!";
            this.qcshowMsgSearchingNotResults = 1;
          } else if (response[0].ErasureResults == "PARTIAL") {
            this.msgerrorqc =
              "Partial - This hard drive hasn’t finished the erasure and/or testing process.";
            this.qcshowMsgSearchingFailedResults = 1;
          } else if (found) {
            console.log("2");
            this.qcshowMsgInfoResults = 1;
          } else {
            console.log("3");
            this.responseQCInspection.push(response[0]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  showManually() {
    this.qcManuallyPoNumber = "";
    this.qcManuallySerialNumber = "";
    this.qcManuallyModel = "";
    this.qcManuallyManufacturer = "";

    if (this.qcShowAddManually) this.qcShowAddManually = false;
    else this.qcShowAddManually = true;
  }

  showDestructionManually() {
    /*this.destructionManuallySerialNumber = '';
    this.destructionManuallyDate = '';
    if(this.destructionShowAddManually)
      this.destructionShowAddManually = false;
    else
      this.destructionShowAddManually = true;*/
  }

  selectChangeHandlerDestruction(event: any) {
    this.poSelectedDestruction =
      event.target.options[event.target.options.selectedIndex].text;
    console.log(this.poSelectedDestruction);
    this.responseDestructionReport = [];
    this._reportService
      .getReportByPo(this.token, this.poSelectedDestruction)
      .subscribe(
        (response) => {
          console.log(this.identity);
          console.log(response);
          this.destructionpo = this.poSelectedDestruction;
          if (response.status == "success") {
            this.cerrado = response.data.name !== "pending";
            //this.cerrado = false;
            //this.desbloquear = (this.identity.role === 'ADMINISTRATOR' || this.identity.sub === response.data.user.id);
            this.desbloquear = true;
            this.currentReport = response.data.id;
            console.log(this.currentReport);
            this.statusContainerByPhysicalDestruction = true;
            // this.responseDestructionReport = JSON.parse(response.data.data);
            // let size = this.responseDestructionReport.length - 1;
            this.destructionposelected = this.poSelectedDestruction;
            // this.destructionclientsname = this.responseDestructionReport[size].clientsname;
            // console.log(this.responseDestructionReport);
            this.getReports();
          } else {
            this.currentReport = 0;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  getReports() {
    this.responseDestructionReport = [];
    this.summaryTotal = {};
    if (this.currentReport != 0) {
      this._reportService
        .getDiscs(this.token, this.currentReport, 1, 100000)
        .subscribe((r) => {
          console.log(r);

          for (let item of r.data) {
            let reporte = JSON.parse(item.data);
            reporte.id = item.id;
            let userREP = item.user;
            userREP = item.user.name[0] + item.user.surname[0];
            reporte.user = userREP;

            if (typeof this.summaryTotal[userREP] !== "undefined") {
              this.summaryTotal[userREP]++;
            } else {
              this.summaryTotal[userREP] = 1;
            }

            this.responseDestructionReport.push(reporte);
          }
          console.log(this.responseDestructionReport);
          $("#destructionhdresults").show();

          console.log(this.summaryTotal);
        });
    }
  }

  displayFn(user?: UserList): string | undefined {
    console.log(user);
    return user ? user.name : undefined;
  }

  public statusSerialNumberSwitch: boolean = true;
  containerBySerialNumberSwitch() {
    this.statusSerialNumberSwitch = !this.statusSerialNumberSwitch;
  }
  public statusContainerByPO: boolean = false;
  containerByPO() {
    this.statusContainerByPO = !this.statusContainerByPO;
  }

  public statusContainerByQC: boolean = false;
  containerByQC() {
    this.statusContainerByQC = !this.statusContainerByQC;
  }

  public statusContainerByPhysicalDestruction: boolean = false;

  AddQCManually() {
    let idrandom = Math.floor(Math.random() * 100 + 1);
    this.qcManuallySerialNumber = this.qcManuallySerialNumber.replace(".", "");
    console.log(this.qcManuallySerialNumber);
    let Enviar = {
      id: idrandom,
      Manufacturer: this.qcManuallyManufacturer,
      ErasureResults: "PASSED",
      Model: this.qcManuallyModel,
      SerialNumber: this.qcManuallySerialNumber,
      PoNumber: this.qcManuallyPoNumber,
    };
    this.responseQCInspection.push(Enviar);
    $("#qchdresults").show();
  }

  public lockCheck = false;

   searchBySN() {
    $("#showMsgSearchingNotResults").hide();
    $("#poshowMsgSearchingNotResults").hide();
    this.typeMatch = 0;
    this.showMsgSearchingNotResults = 0;
    $("#hdresults").hide();
    $("#hdddsnresults").hide();
    $("#hdporesults").hide();
    this.isSecuraze = false;
    this.isEPSPXE = false;
/*     await this.getdatabitraser(); */
    if (this.advancedsearchtext == "") {
      return;
    }
    this.advancedsearchtext = this.advancedsearchtext.replace(".", "");
    console.log(this.advancedsearchtext);
    this.advancedsearchtext = this.advancedsearchtext.trim();

    let tmp = this.deepSearch;

    $("#showMsgSearching").show();

    if (this.deepSearch == 0) this.deepSearch = false;
    if (this.deepSearch == 1) this.deepSearch = true;
    if (this.deepSearch == 2) this.deepSearch = "superdeep";
    this.alertHoldBadHardDrives = "";
    this.alertWrongErasureMethod = false;
    this.alertHoldBadHardDrives = "";
    if (this.deepSearch == 3) {
      //this.openDialog2();
      this.getEPSSZE('sn');
    } else {
      this._hdService
        .searchHDBySerialNumber(
          this.advancedsearchtext,
          this.deepSearch,
          this.daysSearch,
          this.apiCompany
        )
        .subscribe(
          (response) => {
            this.advancedsearchtext = "";

            if (this.deepSearch == false) this.deepSearch = "0";
            if (this.deepSearch == true) this.deepSearch = "1";
            if (this.deepSearch == "superdeep") this.deepSearch = "2";

            console.log(this.deepSearch);

            this.deepSearch = 0;

            if (this.lockCheck) {
              this.deepSearch = tmp;
            }
            $("#showMsgSearching").hide();

            console.log(response);

            if (response.length > 0) {
              if (response[0].typeMatch == 1) {
                this.responseHDSN = response[0];
                this.showsearchResults = 1;
                this.showMsgSearchingNotResults = 0;
                $("#hdresults").show();

                console.log(this.responseHDSN.ErasureMethod);
                var methoddd = this.responseHDSN.ErasureMethod.substring(0, 2);
                console.log(methoddd);
                if (response[0].passDataErasure1 != null) {
                  if (methoddd == "2x")
                    if (response[0].passDataErasure1 != "No")
                      this.alertWrongErasureMethod = true;

                  if (methoddd == "1x")
                    if (response[0].passDataErasure1 != "Yes")
                      this.alertWrongErasureMethod = true;
                }

                if (response[0].ErasureResults == "FAILED")
                  this.alertHoldBadHardDrives = response[0].holdBadHardDrives;
              } else {
                console.log(response[0]);
                console.log(response[0].ErasureResults);
                if (response[0].ErasureResults)
                  if (response[0].ErasureResults == "FAILED") {
                    console.log(response[0].holdBadHardDrives);
                    this.alertHoldBadHardDrives = response[0].holdBadHardDrives;
                    console.log(this.alertHoldBadHardDrives);
                  }

                this.responseHDSN = response;
                this.openDialog();
              }
            } else {
              console.log("no resultados");
              this.showMsgSearchingNotResults = 1;
              this.showsearchResults = 0;
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
    }
  }

  cleanSN() {
    swal
      .fire({
        title: "",
        text: "Are you sure to clean Serial Number?",

        showCancelButton: true,
        buttonsStyling: false,

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-default",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then((result) => {
        if (result.value) {
          this._hdService
            .cleanHDRecord(this.apiCompany, this.responseHDSN.id)
            .subscribe(
              (r) => {
                console.log(r);

                if (r.status === "success") {
                  this.responseHDSN.SerialNumber_new = "";
                  swal.fire({
                    title: "Done!",
                    text: "Serial Number has been cleaned.",
                    buttonsStyling: false,

                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  });
                } else {
                  this.mtds.notifyError(r.msg);
                }
              },
              (error) => {
                this.mtds.notifyError(error.statusText, error.status);
              }
            );
        }
      });
  }

  // constructor(private navbarTitleService: NavbarTitleService, private notificationService: NotificationService) { }

  startAnimationForLineChart(chart: any) {
    let seq: any, delays: any, durations: any;
    seq = 0;
    delays = 80;
    durations = 500;
    chart.on("draw", function (data: any) {
      if (data.type === "line" || data.type === "area") {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path
              .clone()
              .scale(1, 0)
              .translate(0, data.chartRect.height())
              .stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint,
          },
        });
      } else if (data.type === "point") {
        seq++;
        data.element.animate({
          opacity: {
            begin: seq * delays,
            dur: durations,
            from: 0,
            to: 1,
            easing: "ease",
          },
        });
      }
    });

    seq = 0;
  }

  startAnimationForBarChart(chart: any) {
    let seq2: any, delays2: any, durations2: any;
    seq2 = 0;
    delays2 = 80;
    durations2 = 500;
    chart.on("draw", function (data: any) {
      if (data.type === "bar") {
        seq2++;
        data.element.animate({
          opacity: {
            begin: seq2 * delays2,
            dur: durations2,
            from: 0,
            to: 1,
            easing: "ease",
          },
        });
      }
    });

    seq2 = 0;
  }

  searchByInventoryID() {
    $("#showMsgSearchingNotResults").hide();
    $("#poshowMsgSearchingNotResults").hide();
    this.typeMatch = 0;
    this.showMsgSearchingNotResults = 0;
    $("#hdresults").hide();
    $("#hdddsnresults").hide();
    $("#hdporesults").hide();
    this.isSecuraze = false;
    this.isEPSPXE = false;

    if (this.advancedsearchtext == "") {
      return;
    }
    this.advancedsearchtext = this.advancedsearchtext.replace(".", "");
    console.log(this.advancedsearchtext);
    this.advancedsearchtext = this.advancedsearchtext.trim();

    let tmp = this.deepSearch;

    $("#showMsgSearching").show();
    
    this.getEPSSZE('id');
  }

  generateErasureReport() {
    console.log(this.arrayExport);

    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    console.log(fechaHoy);
    var myJSON = JSON.stringify(this.arrayExport);

    let dataEnviar = {
      user_id: this.identity.sub,

      name: fechaHoy,

      type: "DATAERASUREREPORT",

      data: myJSON,
      po: this.posearchtext,
    };

    this._reportService.new(this.token, dataEnviar).subscribe(
      (response) => {
        console.log(response);

        if (response.status == "success") {
          var r = confirm("Press Ok to see report");
          if (r == true) {
            window.open(
              "https://itaderp.com/backend/reports/view-erasure.php?id=" +
                response.data.id +
                "&apitoken=" +
                this.apiCompany,
              "_blank"
            );
          } else if (r == false) {
          }
          this.arrayExport = [];
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  deleteUser() {}

  private _filterCompanies(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.companiesList.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filterCompaniesDestruction(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.companiesListDestruction.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  public ngOnInit() {
    this.filteredCompanies = this.myControlCompanies.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterCompanies(name) : this.companiesList.slice()
      )
    );
    console.log(this.filteredCompanies);

    this.filteredCompaniesDestruction =
      this.myControlCompaniesDestruction.valueChanges.pipe(
        startWith<string | UserList>(""),
        map((value) => (typeof value === "string" ? value : value.name)),
        map((name) =>
          name
            ? this._filterCompaniesDestruction(name)
            : this.companiesListDestruction.slice()
        )
      );
    console.log(this.filteredCompaniesDestruction);
    // register jQuery extension
    $.extend($.expr[":"], {
      focusable: function (el, index, selector) {
        return $(el).is("a, button, :input, [tabindex]");
      },
    });

    $("#SerialNumberMasterItem").on("keypress", function (e) {
      console.log("gola");
      if (e.which == 13) {
        e.preventDefault();
        // Get all focusable elements on the page
        var $canfocus = $(":focusable");
        var index = $canfocus.index(document.activeElement) + 1;
        if (index >= $canfocus.length) index = 0;
        $canfocus.eq(index).focus();
      }
    });

    $("#childAssetag").on("keypress", function (e) {
      if (e.which == 13) {
        e.preventDefault();
        // Get all focusable elements on the page
        var $canfocus = $(":focusable");
        var index = $canfocus.index(document.activeElement) + 1;
        if (index >= $canfocus.length) index = 0;
        $canfocus.eq(index).focus();
      }
    });

    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["pages/lock"]);
    }

    if (this.identity.role == "VENDOR") {
      window.location.href = "/tables/listfiles";
    }

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    console.log(this.apiCompany);
    this._hdService.getHDDetails(this.apiCompany).subscribe(
      (response) => {
        this.totalDiscs = response.totalHDS;
        this.totalDiscsDestroyed = response.totalHDDestroyed;

        this.dataDailySalesChart = {
          labels: ["PASSED", "FAILED"],
          series: [[response.totalHDS, response.totalHDDestroyed]],
        };
        console.log(this.dataDailySalesChart);

        const optionsDailySalesChart = {
          lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: this.totalDiscs, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: { top: 0, right: 0, bottom: 0, left: 15 },
        };

        const dailySalesChart = new Chartist.Line(
          "#dailySalesChart",
          this.dataDailySalesChart,
          optionsDailySalesChart
        );

        this.startAnimationForLineChart(dailySalesChart);
      },
      (error) => {
        console.log(<any>error);
      }
    );

    /* ----------==========     Daily Sales Chart initialization    ==========---------- */

    /* ----------==========     Completed Tasks Chart initialization    ==========---------- */

    const dataCompletedTasksChart = {
      labels: ["D", "L", "M", "M", "J", "V", "S"],
      series: [[100, 80, 95, 90, 89, 120, 96]],
    };

    const optionsCompletedTasksChart = {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0,
      }),
      low: 0,
      high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better
      // look
      chartPadding: { top: 0, right: 0, bottom: 0, left: 0 },
    };

    const completedTasksChart = new Chartist.Line(
      "#completedTasksChart",
      dataCompletedTasksChart,
      optionsCompletedTasksChart
    );

    this.startAnimationForLineChart(completedTasksChart);

    /* ----------==========     Emails Subscription Chart initialization    ==========---------- */

    const dataWebsiteViewsChart = {
      labels: ["SEAGATE", "WDC", "HITACHI", "ATA", "TOSHIBA", "SAMSUNG"],
      series: [[0, 0, 0, 0, 0, 0]],
    };
    const optionsWebsiteViewsChart = {
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: 1000,
      chartPadding: { top: 0, right: 5, bottom: 0, left: 0 },
    };
    const responsiveOptions: any = [
      [
        "screen and (max-width: 640px)",
        {
          seriesBarDistance: 5,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value[0];
            },
          },
        },
      ],
    ];
    const websiteViewsChart = new Chartist.Bar(
      "#websiteViewsChart",
      dataWebsiteViewsChart,
      optionsWebsiteViewsChart,
      responsiveOptions
    );

    this.startAnimationForBarChart(websiteViewsChart);

    $("#worldMap").vectorMap({
      map: "world_en",
      backgroundColor: "transparent",
      borderColor: "#818181",
      borderOpacity: 0.25,
      borderWidth: 1,
      color: "#b3b3b3",
      enableZoom: true,
      hoverColor: "#eee",
      hoverOpacity: null,
      normalizeFunction: "linear",
      scaleColors: ["#b6d6ff", "#005ace"],
      selectedColor: "#c9dfaf",
      selectedRegions: null,
      showTooltip: true,
      onRegionClick: function (element, code, region) {
        var message =
          'You clicked "' +
          region +
          '" which has the code: ' +
          code.toUpperCase();

        alert(message);
      },
    });
  }
  ngAfterViewInit() {
    let me = this;
    $("#showStats").hide();

    if (this.privilegio.level != "VENDOR") {
      $("#showStats").show();
      $(".main-content").show();
    }

    const table = $("#datatables").DataTable();

    // Handle click on "Select all" control
    $("#example-select-all").on("click", function () {
      // Get all rows with search applied
      // var rows = table.rows({ 'search': 'applied' }).nodes();
      var rows = $(".tbody");
      let ptest = $('input[type="checkbox"]', rows);
      var allChecked = $("#example-select-all:checkbox:checked").length > 0;
      console.log(allChecked);
      console.log(ptest);
      let idx = 0;
      for (const child of ptest) {
        let index = me.arrayExport.indexOf(child.id);
        // console.log(index);
        if (
          index == -1 &&
          allChecked &&
          me.responsePOsearch[idx].ErasureResults !== "PARTIAL"
        ) {
          $("#" + child.id, rows).prop("checked", this.checked);
          me.arrayExport.push(child.id);
        } else if (index > -1 && !allChecked) {
          $("#" + child.id, rows).prop("checked", this.checked);
          me.arrayExport.splice(index, 1);
        }

        idx++;
      }

      // Check/uncheck checkboxes for all rows in the table
    });

    // Handle click on checkbox to set state of "Select all" control
    $(".tbody").on("change", 'input[type="checkbox"]', function (e) {
      // If checkbox is not checked
      console.log("entramos");

      let res = e.currentTarget.id;
      if (!this.checked) {
        let index = me.arrayExport.indexOf(res);
        if (index > -1) {
          me.arrayExport.splice(index, 1);
        }

        var el = $("#example-select-all").get(0);
        // If "Select all" control is checked and has 'indeterminate' property
        if (el && el.checked && "indeterminate" in el) {
          // Set visual state of "Select all" control
          // as 'indeterminate'
          el.indeterminate = true;
        }
      } else {
        me.arrayExport.push(res);
      }
    });
  }

  showNotificationError(from: any, align: any) {
    const type = [
      "",
      "info",
      "success",
      "warning",
      "danger",
      "rose",
      "primary",
    ];

    const color = Math.floor(Math.random() * 6 + 1);

    $.notify(
      {
        icon: "notifications",
        message: "There is an error",
      },
      {
        type: "danger",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }

  showNotification(from: any, align: any) {
    const type = [
      "",
      "info",
      "success",
      "warning",
      "danger",
      "rose",
      "primary",
    ];

    const color = Math.floor(Math.random() * 6 + 1);

    $.notify(
      {
        icon: "notifications",
        message: "HDD has been linked successfully",
      },
      {
        type: "success",
        timer: 500,
        placement: {
          from: from,
          align: align,
        },
        template:
          '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          "</div>" +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
          "</div>",
      }
    );
  }
}
